import script from "./RegisterUpdateInfoModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterUpdateInfoModal.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterUpdateInfoModal.vue?vue&type=style&index=0&id=6b3caac8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3caac8"]])

export default __exports__